var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_737_5479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9984,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_737_5479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2131 16.2136C10.4264 16.427 10.7724 16.427 10.9858 16.2136L16.9491 10.25C17.3356 9.86337 17.3356 9.23663 16.9491 8.85005C16.5625 8.46343 15.9357 8.46343 15.5491 8.85005L10.5994 13.8L8.44963 11.65C8.06304 11.2634 7.43622 11.2634 7.04963 11.65C6.66307 12.0366 6.66307 12.6634 7.04963 13.05L10.2131 16.2136ZM11.9994 22C10.6161 22 9.31619 21.7373 8.09961 21.212C6.88302 20.6873 5.82475 19.975 4.92481 19.075C4.02487 18.175 3.31258 17.1167 2.78795 15.9C2.26265 14.6833 2 13.3833 2 12C2 10.6167 2.26265 9.31667 2.78795 8.1C3.31258 6.88333 4.02487 5.825 4.92481 4.925C5.82475 4.025 6.88302 3.31233 8.09961 2.787C9.31619 2.26233 10.6161 2 11.9994 2C13.3826 2 14.6825 2.26233 15.8991 2.787C17.1157 3.31233 18.174 4.025 19.0739 4.925C19.9738 5.825 20.6861 6.88333 21.2108 8.1C21.7361 9.31667 21.9987 10.6167 21.9987 12C21.9987 13.3833 21.7361 14.6833 21.2108 15.9C20.6861 17.1167 19.9738 18.175 19.0739 19.075C18.174 19.975 17.1157 20.6873 15.8991 21.212C14.6825 21.7373 13.3826 22 11.9994 22ZM11.9994 20C14.2159 20 16.1034 19.221 17.662 17.663C19.2199 16.1043 19.9988 14.2167 19.9988 12C19.9988 9.78333 19.2199 7.89567 17.662 6.337C16.1034 4.779 14.2159 4 11.9994 4C9.78283 4 7.89562 4.779 6.33772 6.337C4.77915 7.89567 3.99987 9.78333 3.99987 12C3.99987 14.2167 4.77915 16.1043 6.33772 17.663C7.89562 19.221 9.78283 20 11.9994 20Z",
    fill: "#329A4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8a129859cbba65673ac6ebbaa242061f.svg";
export { ForwardRef as ReactComponent };